<template>
  <div class="custom_data" style="min-width: 120px">
    <label :for="id" class="label_data_input custom_input_label" v-if="label">
      {{ label }}
    </label>
    <v-menu
      v-model="dialog"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <validation-provider
          :name="name || label"
          :rules="rules"
          v-slot="{ errors }"
        >
          <v-text-field
            :error-messages="errors[0]"
            v-model="dateFormatToView"
            readonly
            v-bind="$attrs"
            v-on="disabled ? {} : { ...on, ...$listeners }"
            outlined
            dense
            :id="id"
            :disabled="disabled"
            class="append_icon_date"
          >
            <template #append>
              <v-icon v-if="!value || !clearable">{{ icon }} </v-icon>
              <v-btn
                style="margin-top: 2px"
                icon
                x-small
                v-else
                @click="$emit('input', null)"
              >
                <v-icon x-small> mdi-close </v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </validation-provider>
      </template>
      <v-date-picker
        :min="minDate"
        :max="maxDate"
        :value="dateFormatIso"
        :first-day-of-week="1"
        @input="input"
        :type="type"
        :month-format="getMonthFormat"
        :weekday-format="getWeekFormat"
        :header-date-format="getHeaderDateFormat"
        :title-date-format="getTitleDateFormat"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import {
  dateToLocalString,
  generateText,
  timeToISOString,
} from "@/utils/pureFunctions";

export default {
  name: "CustomDatePicker",
  data: () => ({
    dialog: false,
  }),
  props: {
    startDay: {
      type: Boolean,
      default: true,
    },
    min: {},
    max: {},
    rules: {
      type: [Object, String, Array],
    },
    value: {},
    type: {},
    label: {
      type: String,
    },
    name: {
      type: String,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    min(min) {
      if (min && this.value) {
        if (new Date(min).getTime() > new Date(this.value).getTime()) {
          this.$emit("input", null);
        }
      }
    },
  },
  methods: {
    getWeekTitle(isoDate) {
      let i = new Date(isoDate).getDay();
      return this.$i18n.t(`weekShortTitle.${i}`);
    },
    getMonthFormat(isoDate) {
      let i = new Date(isoDate).getMonth();
      return this.$t(`monthsNames.${i}`);
    },
    getWeekFormat(isoDate) {
      let i = new Date(isoDate).getDay();
      return this.$i18n.t(`weekShort.${i}`);
    },
    getTitleMonthFormat(isoDate) {
      let i = new Date(isoDate).getMonth();
      return this.$t(`monthsNamesShort.${i}`);
    },
    getHeaderDateFormat(isoDate) {
      let year = new Date(isoDate).getFullYear();
      return this.getMonthFormat(isoDate) + ` ${year}`;
    },
    getTitleDateFormat(isoDate) {
      let day = new Date(isoDate).getDate();
      return (
        this.getWeekTitle(isoDate) +
        `, ` +
        this.getTitleMonthFormat(isoDate) +
        ` ${day}`
      );
    },
    input(val) {
      this.$emit("input", new Date(val).toISOStringWithTimeZone(this.startDay));
      this.dialog = false;
    },
  },
  computed: {
    dateFormatIso() {
      return this.value ? timeToISOString(new Date(this.value)) : null;
    },
    dateFormatToView() {
      if (this.value) {
        return dateToLocalString(this.value);
      }
      return null;
    },
    minDate() {
      if (!this.min) return null;
      return timeToISOString(this.min);
    },
    maxDate() {
      if (!this.max) return null;
      return timeToISOString(this.max);
    },
  },
  created() {
    this.id = generateText();
  },
};
</script>

<style scoped></style>
